"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var toolbar_1 = require("@syl-editor/lib/dist/lib/modules/toolbar");
var utils_1 = require("../../utils");
require("./style.css");
var ToolbarInline = /** @class */ (function (_super) {
    __extends(ToolbarInline, _super);
    function ToolbarInline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderTool = function (content, depth, extra) {
            if (depth === void 0) { depth = 0; }
            switch (content.type) {
                case toolbar_1.TOOL_TYPE.MORE: {
                    var groupKey_1 = utils_1.getGroupKey(content);
                    return utils_1.renderMoreToolButton({
                        editor: _this.props.editor,
                        option: _this.props.option,
                        content: content,
                        depth: depth,
                        groupKey: groupKey_1,
                        toolbarType: 'inline',
                        renderMenu: function (tools, _depth) {
                            return tools.map(function (tool) {
                                return _this.renderTool(tool, _depth + 1, {
                                    groupKey: groupKey_1,
                                    config: content.contentOption
                                });
                            });
                        }
                    });
                }
                default:
                    return utils_1.renderSylButton({
                        editor: _this.props.editor,
                        option: _this.props.option,
                        activeFormat: _this.props.activeFormat,
                        content: content,
                        depth: depth,
                        toolbarType: 'inline',
                        extra: extra
                    });
            }
        };
        return _this;
    }
    ToolbarInline.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, visible = _b.visible, editor = _b.editor, toolbarLib = _b.toolbarLib, option = _b.option;
        var contents = toolbarLib.contents;
        var _c = option.className, className = _c === void 0 ? '' : _c;
        return (react_1.default.createElement("div", { className: classnames_1.default('syl-toolbar-inline', (_a = {},
                _a[className] = className,
                _a.visible = visible,
                _a)), onClick: function () { return editor.focus(); } }, contents.map(function (content) { return _this.renderTool(content); })));
    };
    return ToolbarInline;
}(react_1.default.Component));
exports.ToolbarInline = ToolbarInline;
//# sourceMappingURL=index.js.map